/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const dropdownTokens = {
  ContainerBackgroundColorBaseDefault: 'white',
  ContainerBorderWidthBaseDefault: '1px',
  ContainerBorderStyleBaseDefault: 'solid',
  ContainerBorderColorBaseDefault: 'rgba(0, 0, 0, .08)',
  ContainerBorderRadiusBaseDefault: '4px',
  ContainerElevationBaseDefault: '25',
  ContainerSpacingOuterVerticalBaseDefault: '2px',
  ContainerSpacingOuterHorizontalBaseDefault: '0',
  ContainerSpacingInnerVerticalBaseDefault: '6px',
  ContainerSpacingInnerHorizontalBaseDefault: '0',
  ContainerShadowOffsetXBaseDefault: '0',
  ContainerShadowOffsetYBaseDefault: '4px',
  ContainerShadowBlurBaseDefault: '12px',
  ContainerShadowSpreadBaseDefault: '1px',
  ContainerShadowColorBaseDefault: 'rgba(0, 0, 0, .08)',
  HeaderFontColorBaseDefault: '#1c2222',
  HeaderFontSizeBaseDefault: '14px',
  HeaderFontWeightBaseDefault: '600',
  HeaderFontLeadingBaseDefault: '24px',
  HeaderSpacingHorizontalBaseDefault: '12px',
  HeaderSpacingVerticalTopBaseDefault: '20px',
  HeaderSpacingVerticalBottomBaseDefault: '4px',
  ItemSpacingVerticalBaseDefaultDesktop: '6px',
  ItemSpacingVerticalBaseDefaultMobile: '10px',
  ItemSpacingHorizontalBaseDefault: '12px',
  ItemBackgroundColorBaseDefault: '#ffffff',
  ItemBackgroundColorBaseHover: '#ebecec',
  ItemBackgroundColorBaseKeyboardFocus: '#ebecec',
  ItemFontColorBaseDefault: '#1c2222',
  ItemFontColorBaseHover: '#1c2222',
  ItemFontColorBaseSelected: '#1c2222',
  ItemFontColorBaseDisabled: '#a7aaaa',
  ItemFontSizeBaseDefault: '14px',
  ItemFontWeightBaseDefault: '400',
  ItemFontWeightBaseActive: '500',
  ItemFontLeadingBaseDefault: '24px',
  ItemOutlineOffsetBaseKeyboardFocus: '-2px',
  ItemOutlineStrokeBaseKeyboardFocus: '2px solid',
  ItemOutlineColorBaseKeyboardFocus: '#285da3',
  ItemSeparatorBackgroundColorBaseDefault: '#c4c4c4',
  ItemSeparatorBorderWidthBaseDefault: '1px',
  ItemSeparatorSpacingVerticalBaseDefault: '4px',
  BoxDimensionsMaxWidthMinimum: '200px',
  BoxDimensionsMaxWidthFlexible: '80vw',
  BoxDimensionsMaxWidthMaximum: '400px',
} as const;
